const sortDirectionFlow = (currentDirection) => {
  const order = [null, 'desc', 'asc'];
  return order[order.indexOf(currentDirection) + 1] || order[0];
};

export default sortDirectionFlow;
